class ProductMediaInfiniteSlider {
  constructor() {
    this.slider = document.querySelector('.product__media-list');
    if (!this.slider) return;
    
    this.mediaItems = Array.from(this.slider.querySelectorAll('.product__media-item'));
    if (this.mediaItems.length <= 1) return;

    this.totalSlides = this.mediaItems.length;
    this.currentSlide = 1;
    this.isMobile = window.innerWidth < 750;
    this.isTransitioning = false;
    this.isScrolling = false;
    this.scrollTimeout = null;
    
    if (this.isMobile) {
      this.init();
    }

    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 750;
      
      if (this.isMobile && !wasMobile) {
        this.init();
      } else if (!this.isMobile && wasMobile) {
        this.destroy();
      }
    });
  }

  init() {
    this.cleanup();

    // Add clone of first slide
    const firstClone = this.mediaItems[0].cloneNode(true);
    firstClone.classList.add('cloned');
    this.slider.appendChild(firstClone);

    this.replaceControls();
    
    // Track scroll events
    this.boundScrollHandler = this.handleScroll.bind(this);
    this.slider.addEventListener('scroll', this.boundScrollHandler, { passive: true });

    // Track touch events
    this.slider.addEventListener('touchstart', () => {
      this.isScrolling = true;
      clearTimeout(this.scrollTimeout);
    });

    this.slider.addEventListener('touchend', () => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
        this.checkForReset();
      }, 150);
    });
  }

  handleScroll() {
    if (this.isTransitioning) return;

    const scrollLeft = this.slider.scrollLeft;
    const itemWidth = this.mediaItems[0].offsetWidth;
    
    // Calculate current slide position
    const newSlide = Math.round(scrollLeft / itemWidth) + 1;
    
    // Update counter immediately if we're at the clone
    if (scrollLeft >= (this.totalSlides * itemWidth) - 50) {
      this.updateCounter(1, true); // Force instant update
    } else if (newSlide !== this.currentSlide && newSlide <= this.totalSlides) {
      this.currentSlide = newSlide;
      this.updateCounter(this.currentSlide);
    }

    // Clear any existing timeout
    clearTimeout(this.scrollTimeout);
    
    // Start new timeout
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
      this.checkForReset();
    }, 150);

    this.isScrolling = true;
  }

  checkForReset() {
    if (this.isTransitioning || this.isScrolling) return;

    const scrollLeft = this.slider.scrollLeft;
    const itemWidth = this.mediaItems[0].offsetWidth;

    // Only reset if we're at or very near the end
    if (scrollLeft >= (this.totalSlides * itemWidth) - 50) {
      this.isTransitioning = true;
      
      // Quick reset to first position
      requestAnimationFrame(() => {
        this.slider.style.scrollBehavior = 'auto';
        this.slider.scrollLeft = 0;
        this.currentSlide = 1;
        
        requestAnimationFrame(() => {
          this.slider.style.scrollBehavior = '';
          this.isTransitioning = false;
        });
      });
    }
  }

  cleanup() {
    const existingClones = this.slider.querySelectorAll('.cloned');
    existingClones.forEach(clone => clone.remove());

    const existingControls = document.querySelector('.product-media-infinite-slider');
    if (existingControls) {
      existingControls.remove();
    }

    if (this.boundScrollHandler) {
      this.slider.removeEventListener('scroll', this.boundScrollHandler);
    }

    clearTimeout(this.scrollTimeout);
  }

  replaceControls() {
    const dawnControls = document.querySelector('.slider-buttons');
    if (!dawnControls) return;

    const newControls = document.createElement('div');
    newControls.className = 'slider-buttons quick-add-hidden product-media-infinite-slider';
    
    newControls.innerHTML = `
      <button 
        type="button" 
        class="slider-button slider-button--prev" 
        name="previous" 
        aria-label="Previous slide"
      >
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></path>
        </svg>
      </button>
      <div class="slider-counter">
        <span class="slider-counter--current">1</span>
        <span aria-hidden="true"> / </span>
        <span class="visually-hidden">of</span>
        <span class="slider-counter--total">${this.totalSlides}</span>
      </div>
      <button 
        type="button" 
        class="slider-button slider-button--next" 
        name="next" 
        aria-label="Next slide"
      >
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></path>
        </svg>
      </button>
    `;

    dawnControls.parentNode.replaceChild(newControls, dawnControls);

    const nextButton = newControls.querySelector('.slider-button--next');
    const prevButton = newControls.querySelector('.slider-button--prev');
    
    if (nextButton) {
      nextButton.addEventListener('click', () => this.handleButtonClick('next'));
    }
    if (prevButton) {
      prevButton.addEventListener('click', () => this.handleButtonClick('prev'));
    }
  }

  handleButtonClick(direction) {
    if (this.isTransitioning) return;

    const itemWidth = this.mediaItems[0].offsetWidth;
    
    if (direction === 'next') {
      this.slider.scrollBy({ left: itemWidth, behavior: 'smooth' });
    } else {
      if (this.currentSlide > 1) {
        this.slider.scrollBy({ left: -itemWidth, behavior: 'smooth' });
      }
    }

    this.isScrolling = true;
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
      this.checkForReset();
    }, 500);
  }

  updateCounter(currentSlide, instant = false) {
    const counter = document.querySelector('.product-media-infinite-slider .slider-counter--current');
    if (!counter || counter.textContent === currentSlide.toString()) return;

    if (instant) {
      // Instant update without transition
      counter.textContent = currentSlide;
    } else {
      // Quick fade for normal updates
      counter.style.opacity = '0';
      counter.textContent = currentSlide;
      requestAnimationFrame(() => {
        counter.style.opacity = '1';
      });
    }
  }

  destroy() {
    this.cleanup();
    this.slider.scrollLeft = 0;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductMediaInfiniteSlider();
});